import React, { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { getImages } from './const'

const Header = ({secref}) => {
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    
    const closeMenu = () => {
        setisMob(false);
        // setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    const location = useLocation();
  return (
    <>
        <header className={`header-wrap ${location.pathname === "/" ? "" : "inner-header-wrap"}`} ref={secref}>
            <div className='container container-lg'>
                <div className='header-flex d-flex justify-content-between'>
                    <div className='main-logo d-flex align-items-center'>
                        <Link to="/"><img src={getImages('alpha-one-logo.webp')}/></Link>
                    </div>
                    <div className={`main-menu ${isMob ? 'active' : ''}`}>
                        <div className='d-lg-none'>
                            <div className='social-links'>
                                <Link to="tel:5127771240">
                                    <img src={getImages('black-phone-material.svg')}/>
                                </Link>
                                <a href='https://www.facebook.com/alphaonemotors/' target='_blank' className='ms-3'><img src={getImages('fb-icon.svg')}/></a>
                                <a href='https://www.instagram.com/alpha_one_motors/' target='_blank' className='ms-3'><img src={getImages('instagram-font-awesome.svg')}/></a>
                            </div>
                        </div>
                        <ul className='d-flex align-items-center'>
                            <li>
                                <NavLink to="/" onClick={closeMenu}>Home</NavLink>
                            </li>
                            <li>
                                <NavLink to="/why-us" onClick={closeMenu}>Why Us</NavLink>
                            </li>
                            <li>
                                <NavLink to="/sell-my-exotic" onClick={closeMenu}>Sell my Exotic</NavLink>
                            </li>
                            <li>
                                <NavLink to="/about-us" onClick={closeMenu}>ABOUT US</NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact-us" onClick={closeMenu}>Contact</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='d-lg-flex align-items-center d-none mb-5'>
                        <div>
                            <Link to="tel:5127771240" className='phone-no'>
                                <span className='phone-icon'></span> <span className='d-none d-md-inline-block'>(512) 777-1240</span>
                            </Link>
                        </div>
                        <div className='social-links ms-4'>
                            <a href='https://www.facebook.com/alphaonemotors/' target='_blank' className='ms-3'><img src={getImages('fb-icon.svg')}/></a>
                            <a href='https://www.instagram.com/alpha_one_motors/' target='_blank' className='ms-3'><img src={getImages('instagram-font-awesome.svg')}/></a>
                        </div>
                    </div>
                    <div className={`overflow-bg d-lg-none ${isMob ? 'active' : ''
                        }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                    <div
                        className={`mobile-inner-header d-lg-none ${isMob ? 'active' : ''}`}
                        onClick={() => onChangeBodyClass(!isMob)}
                    >
                        <div
                            className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                }`}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </>
  )
}

export default Header